import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails"; 
import styled from "@emotion/styled";

const Typo = styled.div`
  font-family: "two-cent-regular";
  color: black;
`;

const SimpleAccordion = (props) => {
  const [expanded, setExpanded] = React.useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      {props.accContent.map((text, index) => (
        <Accordion
          // data-aos="fade-zoom-in"
          // data-aos-easing="ease-in"
          // data-aos-delay="500"
          // data-aos-offset="0"
          key={index}
          expanded={expanded === `panel${index}`}
          onChange={handleChange(`panel${index}`)}
          sx={{
            backgroundColor: "#fff",
            color: "black",
            marginY: "12px",
            paddingY: "17px",
          }}
        >
          <AccordionSummary
            expandIcon={
              <span
                style={{ color: "black" }}
                className="material-symbols-outlined"
              >
                +
              </span>
            }
            aria-controls={"panel" + index + "a-content"}
            id={"panel" + index + "a-header"}
          >
            <Typo>{text[0]}</Typo>
          </AccordionSummary>
          <AccordionDetails>
            <Typo>{text[1]}</Typo>
            <Typo>{text[2]}</Typo>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default React.memo(SimpleAccordion);
